import styled from 'astroturf/react';
import _NewLine from "NewLine.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/NewLine.tsx?styleId=NewLine";


export const NewLine = /*#__PURE__*/styled("div", null, {
  displayName: "NewLine",
  styles: _NewLine
});
